import clsx from 'clsx';
import styles from './Progressbar.module.scss';

type Props = {
    width: number;
    height: number;
    color?: string;
    disabled?: boolean;
};

function Progressbar({ width, height, color, disabled }: Props) {
    return (
        <div className={clsx(styles.Progressbar, { [styles.Disabled]: disabled })} style={{ height: height + 'px' }}>
            <div className={styles.ProgressbarFill} style={{ width: `${width}%`, height: height + 'px', backgroundColor: color }}></div>
        </div>
    );
}

export default Progressbar;
